module.exports = __webpack_public_path__ + "assets/img/26.5f030632.png";